jQuery().ready(function($) {

  var locationSwiper = $(".location-swiper");

  if ( locationSwiper.length ) {

    var swiper = new Swiper('.swiper-container.location-swiper', {
      spaceBetween: 30,
      effect: 'fade',
      loop: true,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      preloadImages: false,
        lazy: {
          loadPrevNext: true,
          checkInView: true,
        },
    });
  
  }  

    // change size of item by toggling full class
    $('.grid-toggle').on("click",function(e) {
      var grid = $('#image-grid-list');
      if ($(this).hasClass('list')) {
        grid.addClass('full');
      }
      else if($(this).hasClass('grid')) {
        grid.removeClass('full');
      }

      $('.grid-toggle').removeClass('active');
      $(this).addClass('active');

      // trigger layout after item size changes
      grid.masonry('layout');
    });


    // resize swiper container
    var swiperSlideContainer = $("#swiper-slide-cell");

    if ( swiperSlideContainer.length ) {

      var windowWidth = $(window).width();
      var sectionContentWidth = 1240;
      if ( windowWidth > 1240 ) {
        var offsetMarginLeft = 500;//((windowWidth - sectionContentWidth)/2)+16;
        //swiperSlideContainer.css({marginLeft: -offsetMarginLeft, width: "calc(100% - " + offsetMarginLeft + "px)"});
        var timer;

        setTimeout(function(){swiper.update();}, 400);
      }
  
    }

    // lazy load grid images
    var grid = $('#image-grid-list');
    $("img.lazy").Lazy({
      effect: 'fadeIn',
      effectTime: 400,
      visibleOnly: true,
      threshold: 0,
      onError: function(element) {
        console.log('error loading ' + element.data('src'));
      },
      afterLoad: function(element) {
        // called after an element was successfully handled
        grid.masonry('layout'); // refresh masonry layout
      }
    });

  });